export const PRODUCT_LIST_CATEGORY = 'category';
export const PRODUCT_LIST_SEARCH_RESULTS = 'search results';
export const PRODUCT_LIST_RECOMMMENDATIONS = 'recommendations';
export const PRODUCT_LIST_PRODUCT_SLIDER = 'product slider';

export const CART_STEP_1 = 1;
export const CART_STEP_2 = 2;

export const FORM_TYPE_MIGROS_FEEDBACK = 'Feedback';
export const FORM_TYPE_PICKER_RATING = 'Bewertung';
export const FORM_TYPE_ZIP = 'plz-eingabe';

export const UPDATE_ZIP_EVENT = 'plz-aenderung';
export const SUBSCRIBE_EVENT = 'anmeldung-formular';



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/constants.js